import { Component, Input, ElementRef, AfterViewInit, Renderer2 } from '@angular/core';

@Component({
	selector: 'row-tooltip',
	templateUrl: './tooltip.component.html',
	styleUrls: ['./tooltip.component.scss'],
})
export class TranscriptionTooltipComponent implements AfterViewInit {
	@Input() content?: string;
	isHovering = false;

	constructor(private el: ElementRef, private renderer: Renderer2) {}

	ngAfterViewInit(): void {
		const hostElement = this.el.nativeElement.parentElement;
		hostElement.addEventListener('mouseover', this.showTooltip.bind(this));
		hostElement.addEventListener('mouseout', this.hideTooltip.bind(this));
		let parentTd = this.el.nativeElement.closest('.overflowing-td');

		if (parentTd) {
			this.renderer.listen(this.el.nativeElement, 'mouseover', () => {
				this.renderer.setStyle(parentTd, 'overflow', 'visible');
			});

			this.renderer.listen(this.el.nativeElement, 'mouseout', () => {
				this.renderer.setStyle(parentTd, 'overflow', 'hidden'); // Or whatever the original value was
			});
		}
	}

	showTooltip() {
		this.isHovering = true;
	}

	hideTooltip() {
		this.isHovering = false;
	}
}
